import { __decorate, __metadata } from "tslib";
import { IsOptional, IsUUID } from 'class-validator';
import { PagedQuery } from '../core';
/**
 * Requests a list of users within a courtSystem along with their userGroups,
 * optionally filtering by searchTerms and userGroupId.
 */
export class ListUsersForCourtSystemQuery extends PagedQuery {
    constructor(page) {
        super(page);
    }
}
__decorate([
    IsOptional(),
    __metadata("design:type", String)
], ListUsersForCourtSystemQuery.prototype, "searchTerms", void 0);
__decorate([
    IsOptional(),
    IsUUID(),
    __metadata("design:type", String)
], ListUsersForCourtSystemQuery.prototype, "userGroupId", void 0);
